<template>
  <div class="personnel">
    <div class="live">
      <el-row>
        <router-link to="/system/role/add">
          <el-button round type="primary" @click="linkTo()">添加角色</el-button>
        </router-link>

        <!-- <div class="seach-list r iblock">
          <el-select class="input-v" v-model="search.status" @change="seachStatus">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            placeholder="搜索课程"
            v-model="search.keywords"
            round
            class="input-with-select input-sea r"
          >
            <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
          </el-input>
        </div> -->
      </el-row>
    </div>
    <!-- //表格数据 -->
    <div class="list-wrap" v-if="resultData.list" v-loading="loading">
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 20px 0;"
      >
        <el-table-column prop="name" label="角色"></el-table-column>
        <el-table-column prop="desp" label="描述">
          <!-- <template slot-scope="scope">
            <span v-show="scope.row.state==0">无</span>
            <span v-show="scope.row.state==1">有</span>
          </template>-->
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="Delete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="tc mt20">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>-->
    </div>
  </div>
</template>

<script>
import { _roleIndex, _removeRole } from "@/api/role";


export default {
  created() {
    this.initRoleList();
  },
  components:{
  },
  data() {
    return {
      ruleForm:{
        course_cover:''
      },
      loading: false,
      search: {
        keywords: "",
        status: "0",
        page: "1",
        size: "10"
      },
      course_id: "", //课程id
      options: [
        {
          label: "全部状态",
          value: "0"
        },
        {
          label: "待上架",
          value: "1"
        },
        {
          label: "已上架",
          value: "2"
        },
        {
          label: "已下架",
          value: "3"
        }
      ],
      resultData: []
      // 翻页信息
    };
  },
  methods: {
    //加载列表
    initRoleList() {
      this.loading = true;
      _roleIndex({
        params: {
          page: this.search.page,
          size: this.search.size,
          keywords: this.search.keywords,
          state: this.search.status
        }
      }).then(res => {
        // console.log(res);
        this.loading = false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    linkTo() {
      let routeData = this.$router.resolve({
        path: "/system/role/add"
      });
      window.open(routeData.href, "_blank");
    },
    //状态查询信息
    seachStatus(val) {
      // console.log(val);
      this.initRoleList();
    },
    //关键字查询信息
    seachList() {
      this.initRoleList();
    },
    // 编辑：
    edit(item) {
      let routeData = this.$router.resolve({
        path: `/system/role/edit/${item.id}`
        // params:{userId} //可添加参数
      });
      window.open(routeData.href, "_blank");
    },
    Delete(id) {
      this.$confirm("此操作将删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          _removeRole({
            params: {
              id: id
            }
          }).then(res => {
            if (res.resultCode == 1) {
              this.$message.success(res.errorMsg);
              this.initRoleList();
            } else {
              this.$message.error(res.errorMsg);
            }
          });
        })
        .catch(() => {});
    },
    //翻页
    handleCurrentChange(val) {
      // console.log(val);
      this.page = val;
      this.initRoleList();
    },
      uploadSuccess1(url) {
      console.log(url);
      // this.ruleForm.course_cover=url;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.live {
  .seach-list {
    .input-v {
      // width: 160px;
      margin-left: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
.img_code {
  width: 150px;
  height: 150px;
  border: 1px solid #000;
  margin: 0 auto;
  margin-top: 20px;
  img {
    width: 100%;
  }
}
</style>